module.exports = __webpack_public_path__ + "img/meishida.c468f566.png";